import { render, staticRenderFns } from "./ARPurchaseHistory.vue?vue&type=template&id=752a4ec6&scoped=true&"
import script from "./ARPurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./ARPurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./ARPurchaseHistory.vue?vue&type=style&index=0&id=752a4ec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752a4ec6",
  null
  
)

component.options.__file = "ARPurchaseHistory.vue"
export default component.exports